<template>
  <div class="links cards mx-auto shadow pb-5 mb-5">
    <div
      class="h1 mb-4 card-title-border link-container d-inline-block primary-font bg-light py-2"
    >
      Links
    </div>
    <!-- TODO Add cool cascade effect, make each tab/title box be a link -->
    <div
      class="link-block shadow mx-autolux d-inline-block text-nowrap"
      :class="isLinkActive(0)"
      @click="hoverOver(0)"
    >
      <!-- :class="{'classOne classTwo': isActive}" -->
      <!-- Delete animate.css from node modules; getting imported in HTML -->
      <span>LinkedIn</span>
      <!-- Replace title with font awesome icon component -->
    </div>
    <div class="h2 mx-autolux text-underline mt-3 primary-font">
      GitHub Repositories
      <font-awesome-icon icon="code-branch" />
    </div>
    <div class="d-flex justify-content-center mt-5" v-if="isLoading">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div
      v-for="(item, index) in repos"
      :key="item.id"
      class="link-block shadow my-4 d-inline-block text-nowrap mr-2"
      :class="isLinkActive(index + 1)"
      @click="hoverOver(index + 1)"
      v-b-tooltip.hover
      :title="`${item.description}`"
    >
      <span> {{ item.html_url.replace("https://github.com/maxWN/", "") }}</span>
    </div>
    <!-- <div class="link-block shadow mx-auto">HackerRank</div> -->
  </div>
</template>

<script>
import blogsService from "@/services/blogService";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCodeBranch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faCodeBranch);

export default {
  name: "LinksView",
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      isHovering: false,
      classes: [],
      selected: null,
      links: ["https://www.linkedin.com/in/max-nakel-78a0aa159/"],
      repos: null,
      isLoading: false,
    };
  },
  created() {
    this.getRepos();
  },
  methods: {
    // https://stackoverflow.com/questions/53492148/animating-a-vue-component-using-mouseover-and-mouseout
    hoverOver(key) {
      console.log(`our key value: ${key}.`);
      this.selected = key;
      this.classes = ["animated", "bounceIn", "bg-secondary", "text-light"]; //(this.isValueEven(key) ? 'my-4' : null)];
      setTimeout(this.navigateOut(key), 1500);
    },
    hoverOut() {
      this.classes = [];
    },
    navigateOut(key) {
      window.location.assign(this.links[key]);
    },
    isLinkActive(link) {
      return this.classes && this.selected == link ? this.classes : [];
    },
    // isValueEven(val) {
    //   let num = val % 2;
    //   return (val == 0 || num == 0) ? true : false;
    // },
    async getRepos() {
      this.isLoading = true;
      let response = await blogsService.getGitHubRepos();
      this.repos = response.data;
      this.repos.forEach((element) => {
        this.links.push(element.html_url);
      });
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss">
.links {
  margin-top: 5%;
  .link-container {
    padding-left: 25%;
    padding-right: 25%;
    width: 100%;
  }
  .mx-autolux {
    margin-left: 30%;
    margin-right: 30%;
  }
}
</style>
